export const SuitabilityQuestionsIntl = {
  NetWorth: {
    individual: {
      id: 'suitability-questionnaire-net-worth-over-1m-text',
      defaultMessage: 'My <strong>net worth is $1M+</strong>\n(excluding primary residence)',
    },
    entity: {
      id: 'suitability-questionnaire-net-worth-over-1m-entity-text',
      defaultMessage: 'The <strong>net worth of each owner is $1M+</strong>\n(excluding primary residence)',
    },
  },

  IndividualIncome: {
    individual: {
      id: 'suitability-questionnaire-income-over-200k-text',
      defaultMessage: 'My <strong>individual income was $200k+</strong> for each of the past two years',
    },

    entity: {
      id: 'suitability-questionnaire-income-over-200k-entity-text',
      defaultMessage: 'The <strong>individual income of each owner was $200k+</strong> for each of the past two years',
    },
  },

  JointIncome: {
    individual: {
      id: 'suitability-questionnaire-household-income-over-300k-text',
      defaultMessage: 'My joint <strong>household income was $300k+</strong> for each of the past two years',
    },

    entity: {
      id: 'suitability-questionnaire-household-income-over-300k-entity-text',
      defaultMessage:
        'For each owner, their joint <strong>income including their spouse was $300k+</strong> for each of the past two years',
    },
  },

  OrganizationAssets: {
    id: 'suitability-questionnaire-organization-assets-over-5m-text',
    defaultMessage: 'The entity has <strong>total assets exceeding $5,000,000</strong>',
  },

  AssociatedWithFinra: {
    id: 'suitability-questionnaire-associated-with-finra-text',
    defaultMessage: 'Are you or anyone in your household associated with a <strong>FINRA Member?</strong>',
  },

  FinraMemberNames: {
    id: 'suitability-questionnaire-finra-members-names-label',
    defaultMessage: 'List member names (separate with a comma)',
  },

  AssociatedWithPublicCompany: {
    id: 'suitability-questionnaire-net-worth-text',
    defaultMessage:
      'Are you or anyone in your household or immediate family a 10% shareholder, officer, or member of the board of directors of a <strong>publicly traded company?</strong>',
  },

  PublicCompanyTickers: {
    id: 'suitability-questionnaire-public-company-tickers-label',
    defaultMessage: 'List company tickers (separate with a comma)',
  },
} as const;
